module.exports = __webpack_public_path__ + "static/media/cactus.6953a917.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/cactus.svg
// module id = 2517
// module chunks = 7